module.exports = __webpack_public_path__ + "img/box9-06.4824bba9.png";